<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection"> </el-table-column>
					<el-table-column prop="Title" label="文档标题" width></el-table-column>

					<el-table-column prop="IsPublish" label="是否发布" width="">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsPublish == 1 ? 'success' : 'info'" disable-transitions>{{
								scope.row.IsPublish == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="DepartmentName" label="所属机构" width> </el-table-column>
					<el-table-column prop="Sort" label="排序" width> </el-table-column>
					<el-table-column prop="CreateBy" label="创建人" width>

					</el-table-column>

					<el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime"
						width></el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="editForm.Title" auto-complete="off"></el-input>
					</el-form-item>
					<!-- <el-form-item label="封面">
						<el-upload class="avatar-uploader" name="Files" :action="BaseApiUrl + '/images/Upload/Pic'"
							:show-file-list="false" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="imageUrl" v-oss-src="imageUrl" class="avatar" />
							<i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item> -->

					<el-form-item label="所属机构" v-if="options && options.length > 0" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="isResouceShow"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="editForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="editForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="editForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="addForm.Title" auto-complete="off"></el-input>
					</el-form-item>
					<!-- <el-form-item label="封面">
						<el-upload class="avatar-uploader" name="Files" :action="BaseApiUrl + '/images/Upload/Pic'"
							:show-file-list="false" :on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload">
							<img v-if="imageUrl" v-oss-src="imageUrl" class="avatar" />
							<i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item> -->

					<el-form-item label="所属机构" v-if="options && options.length > 0" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="isResouceShow"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="addForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="addForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="addForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" :data="quillUploadData" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getNoticeRecordListPage, editNoticeRecord, addNoticeRecord, deleteNoticeRecord } from '../../api/modules/misc';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { prepareDeptCascaderTree } from '../../utils/deptCascaderProps'
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import {
	buildLocalPicUploadData,
	normalizeRichTextHtmlForSave,
	prepareRichTextHtmlForDisplay,
	stripOssPresignParams,
} from '../../utils/ossMediaUpload'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			quillUploadData: buildLocalPicUploadData('NoticeRecord'),
			imageUrl: '',
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],

				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Href: '',
				imageUrl: '',
				Title: '',
				Content: '',
				IsPublish: '',
				Sort: '',
				Dids: [],
				DepartmentId: 0,
				Type: 1,
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				Title: '',
				Href: '',
				imageUrl: '',
				Content: '',
				IsTop: '',
				IsPublish: '',
				Sort: 1,
				Dids: [],
				DepartmentId: 0,
				Type: 1
			},
			DepartmentId: 0,
			multipleSelection: [],
		}
	},
	methods: {
		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				type: 1,
				departmentId: this.DepartmentId,
			}
			getNoticeRecordListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				type: 1,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getNoticeRecordListPage(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			// 按顶部固定学校/左侧选中部门加载树，避免总平台/其他学校。最后更新：2026-08-29
			const schoolId = this.$store.state.activeSchoolId
				|| window.localStorage.getItem('activeSchoolId')
				|| this.DepartmentId;
			if (!schoolId || Number(schoolId) <= 0) {
				this.$message.warning("请先选择学校");
				return;
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Content) {
				this.editForm.Content = prepareRichTextHtmlForDisplay(this.editForm.Content, this.BaseApiUrl)
			}
			this.imageUrl = this.editForm.imageUrl

			let optionsTemp = [];
			let para = { pid: 0, type: 1, scopeDepartmentId: schoolId };
			getTeachingDepartmentTree(para).then((res) => {
				const root = res.data && res.data.response;
				if (root) optionsTemp.push(root);
				this.options = optionsTemp;
			})
		},
		//显示新增界面
		handleAdd() {
			// 按顶部固定学校/左侧选中部门加载树，避免总平台/其他学校。最后更新：2026-08-29
			const schoolId = this.$store.state.activeSchoolId
				|| window.localStorage.getItem('activeSchoolId')
				|| this.DepartmentId;
			if (!schoolId || Number(schoolId) <= 0) {
				this.$message.warning("请先选择学校");
				return;
			}
			this.addFormVisible = true
			this.addForm = {
				Title: '',
				Href: '',
				Content: '',
				IsTop: false,
				IsPublish: true,
				Sort: 1,
				DepartmentId: '',
				Type: 1,
			}
			let optionsTemp = [];
			this.imageUrl = ''
			let para = { pid: 0, type: 1, scopeDepartmentId: schoolId };
			getTeachingDepartmentTree(para).then((res) => {
				const root = res.data && res.data.response;
				if (root) optionsTemp.push(root)
				this.options = optionsTemp
			})
		},
		handleAvatarSuccess(res, file) {
			this.imageLoadding = false
			console.log(res)
			this.imageUrl = res.response
		},

		quillSuccess(response) {
			if (!response.success) {
				this.$message({
					message: response.msg,
					type: 'error',
				})
				return
			}
			const editorRef = this.$refs.myQuillEditor
			const editor = Array.isArray(editorRef) ? editorRef.find((e) => e && e.quill) : editorRef
			const quill = editor && editor.quill
			if (!quill) {
				this.$message.error('编辑器未就绪')
				return
			}
			const range = quill.getSelection()
			const pos = range ? range.index : quill.getLength()
			const stablePath = stripOssPresignParams(response.response)
			quill.insertEmbed(pos, 'image', this.$resolveImageSrc(stablePath))
		},
		normalizeContentForSave(form) {
			if (!form || form.Content == null) return
			form.Content = normalizeRichTextHtmlForSave(form.Content, this.BaseApiUrl)
		},
		beforeAvatarUpload(file) {
			// 这里可以过滤不要的文件
			this.imageLoadding = true
			return true
		},
		//编辑
		editSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.editLoading = true
						//NProgress.start();
						this.editForm.imageUrl = this.imageUrl
						this.normalizeContentForSave(this.editForm)
						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.addLoading = true
						//NProgress.start();
						this.addForm.imageUrl = this.imageUrl
						this.normalizeContentForSave(this.addForm)
						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteNoticeRecord(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}
</style>
